import AppProvider from './AppProvider';

export default AppProvider;
